import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import '../About/AboutPage.css';
import PageHeader from '../Common/PageHeader';

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>Bakumia | Unique Home & Kitchen Products</title>
        <meta
          name="keywords"
          content="creative items, unique home accessories, best home decor gifts, unique kitchen tools, modern home decor"
        />
        <meta
          name="description"
          content="Bakumia offers unique home and kitchen products at affordable prices. Explore modern decor, functional kitchen tools, and thoughtful gift ideas."
        />
      </Helmet>

      <PageHeader title="About Us" />

      <section className="about-section">
        <div className="container-fluid">
          {/* Intro */}
          <div className="text-center mb-5">
            <h2 className="section-title">Who We Are</h2>
            <p className="section-subtitle w-100 mx-auto">
              At Bakumia, we provide stylish and practical products to transform
              your home. From modern decorative pieces to unique kitchen tools,
              our carefully selected collection is made to inspire your everyday
              living.
            </p>
          </div>

          {/* Mission Section */}
          <div className="row align-items-center mb-5">
            <div className="col-md-6 text-center">
              <img
                src="https://mortonme.com/wp-content/uploads/2024/08/1-1-e1723553277524-1024x464.png"
                alt="About Bakumia"
                className="about-image"
                draggable="false"
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
            <div className="col-md-6">
              <h2 className="section-title text-md-start text-center">
                Our Mission
              </h2>
              <p className="text-muted lh-lg text-md-start text-center">
                We aim to make unique and quality home decor accessible to
                everyone. Whether upgrading your living space, enhancing your
                kitchen, or finding the perfect gift, our products add both
                style and function.
              </p>
            </div>
          </div>

          {/* Product Categories */}
          <div className="text-center mb-5">
            <h2 className="section-title">Our Best Products</h2>
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="about-card">
                <h3>• Home Decor</h3>
                <p>
                  Transform your space with modern <b>decorative items</b> and
                  accessories at unbeatable prices.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-card">
                <h3>• Kitchen Tools</h3>
                <p>
                  Upgrade your kitchen with <b>unique kitchenware</b> that's
                  both stylish and functional.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="about-card">
                <h3>• Gifts</h3>
                <p>
                  Discover thoughtful, stylish <b>home decor gifts</b> perfect
                  for loved ones.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className=" about-card d-flex flex-column align-items-start justify-content-between">
                <div>
                  <h3>Ready to Shop?</h3>
                  <p>
                    Browse our full collection and find your next favorite item.
                  </p>
                </div>
                <Link to="/shop" className="about-btn">
                  Order Now <i className="fa fa-arrow-right ms-2" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
